export const cities = [
  {
    id: 'tel-aviv',
    name: { he: 'תל אביב', en: 'Tel Aviv' },
    cemeteries: [
      { he: 'קרית שאול', en: 'Kiryat Shaul' },
      { he: 'ירקון', en: 'Yarkon' }
    ]
  },
  {
    id: 'holon',
    name: { he: 'חולון', en: 'Holon' },
    cemeteries: [
      { he: 'בית העלמין דרום', en: 'South Cemetery' }
    ]
  },
  {
    id: 'rishon-lezion',
    name: { he: 'ראשון לציון', en: 'Rishon LeZion' },
    cemeteries: [
      { he: 'גני אסתר', en: 'Ganei Esther' },
      { he: 'שיכון גורדון', en: 'Shikun Gordon' }
    ]
  },
  {
    id: 'petah-tikva',
    name: { he: 'פתח תקווה', en: 'Petah Tikva' },
    cemeteries: [
      { he: 'סגולה', en: 'Segula' },
      { he: 'ירקון', en: 'Yarkon' }
    ]
  },
  {
    id: 'bat-yam',
    name: { he: 'בת ים', en: 'Bat Yam' },
    cemeteries: []
  },
  {
    id: 'haifa',
    name: { he: 'חיפה', en: 'Haifa' },
    cemeteries: [
      { he: 'שדה יהושע', en: 'Sde Yehoshua' },
      { he: 'תל רגב', en: 'Tel Regev' }
    ]
  },
  {
    id: 'netanya',
    name: { he: 'נתניה', en: 'Netanya' },
    cemeteries: []
  },
  {
    id: 'kfar-saba',
    name: { he: 'כפר סבא', en: 'Kfar Saba' },
    cemeteries: []
  },
  {
    id: 'raanana',
    name: { he: 'רעננה', en: 'Ra\'anana' },
    cemeteries: []
  },
  {
    id: 'herzliya',
    name: { he: 'הרצליה', en: 'Herzliya' },
    cemeteries: []
  }
];

export const getCityById = (id) => cities.find(city => city.id === id);
export const getCityBySlug = (slug) => cities.find(city => city.id === slug || city.name.he === slug || city.name.en.toLowerCase().replace(/'/g, '') === slug.toLowerCase());

